/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authenticationCreateAccessToken } from "../../funcs/authenticationCreateAccessToken.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.AuthTokenRequest$inboundSchema,
};

export const tool$authenticationCreateAccessToken: ToolDefinition<typeof args> =
  {
    name: "authentication-create-access-token",
    description: `Create or refresh an access token.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await authenticationCreateAccessToken(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value.result;

      return formatResult(value, apiCall);
    },
  };
